import Vue from 'vue'
import Router from 'vue-router'
import Login from "../components/Login"
import Home from "../components/Home"
import MobileDetailed from "../components/MobileDetailed";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/MobileDetailed',
      name: 'MobileDetailed',
      component: MobileDetailed
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js